<template>
  <base-dialog show-close :visible.sync="visible" class="update-department-dialog" width="485px">
    <template v-slot:header>编辑部门</template>
    <el-form ref="form" :model="form" label-width="110px" :rules="rules" label-position="left">
      <el-form-item label="部门名称" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="上级部门" prop="parentDepartment">
        <user-scope-selector
          tip="选择部门"
          v-model="form.parentDepartment"
          :show-user-tab="false"
          :root-department="rootDepartment"
          show-raw-root-department-name
        ></user-scope-selector>
      </el-form-item>
      <el-form-item label="部门负责人" prop="admin">
        <user-scope-selector
          tip="选择部门负责人"
          v-model="form.admin"
          :show-department-tab="false"
          :root-department="rootDepartment"
          :users="curCompanyUsers"
          show-raw-root-department-name
          multiple
        ></user-scope-selector>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import UserScopeSelector from "@/components/UIComponents/UserScopeSelector"
import { saveDepartment } from "@/api/department"

export default {
  name: "update-department-dialog",
  components: { BaseDialog, BaseButton, UserScopeSelector },
  inject: ["curCompanyUsers", "rootDepartment"],
  data() {
    return {
      visible: false,
      rules: {
        name: [{ required: true, message: "请填写部门名称", trigger: "blur" }],
        parentDepartment: [{ required: true, message: "上级部门不能为空", trigger: "blur" }]
      },
      form: {
        id: "",
        name: "",
        parentDepartment: [],
        admin: []
      }
    }
  },
  methods: {
    open(department) {
      if (department) {
        this.form.id = department.id
        this.form.name = department.name
        this.form.admin = department.adminIds.map(id => ({ type: "user", value: id }))
        this.form.parentDepartment = [{ type: "department", value: department.parentId }]
      }
      this.visible = true
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        let parentId = this.form.parentDepartment[0]?.value
        if (!parentId) {
          this.$message.error("上级部门不能为空")
          return
        }
        saveDepartment({
          id: this.form.id,
          name: this.form.name,
          parentId: parentId,
          adminIds: this.form.admin.map(item => item.value)
        }).then(() => {
          this.$message.success("更新成功")
          this.$emit("change")
          this.visible = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.update-department-dialog {
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 18px 60px 8px 24px;
    }
  }
  .el-form ::v-deep {
    .el-form-item {
      margin-bottom: 8px;
      .el-form-item__error {
        position: relative;
      }
    }
    .el-form-item__label,
    .el-form-item__content,
    .el-input,
    .el-cascader {
      line-height: 32px;
    }
    .el-cascader {
      width: 100%;
    }
  }
}
</style>
